import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../consts";
import { t } from "../../services";
import { withSection } from "../../hoc";

import { FlexContainers, Modal, Paragraph2, SmallButton, WrapperContainer } from "../../components";

const TIMEOUT = 30;

const IdleModal = ({ active, setActive, onLogout = () => {} }) => {
  const [secondsLeft, setSecondsLeft] = useState(TIMEOUT);
  const [intervalId, setIntervalId] = useState();

  useEffect(() => {
    if (active) {
      const interval = setInterval(() => {
        setSecondsLeft((prev) => prev - 1);
      }, 1000);

      setIntervalId(interval);
    }

    return () => {
      resetInterval();
    };
  }, [active]);

  const resetInterval = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
      setSecondsLeft(TIMEOUT);
    }
  };

  useEffect(() => {
    if (secondsLeft === 0) {
      logout();
    }
  }, [secondsLeft]);

  const stayActive = () => {
    resetInterval();
    setActive(false);
  };

  const logout = () => {
    onLogout();
    resetInterval();
    setActive(false);
  };

  return (
    <Modal id="idle-modal" active={active} closable={false} title={t(strCode.IDLE_MODAL_TITLE)}>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={32} maxWidth={600}>
        <WrapperContainer Container={FlexContainers.FlexColumnStart}>
          <Paragraph2>{t(strCode.IDLE_MODAL_MESSAGE)}</Paragraph2>
        </WrapperContainer>
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16} width={"100%"}>
          <SmallButton secondary secondaryBold onClick={logout}>{`${t(
            strCode.LOGOUT_BTN
          )} (${secondsLeft})`}</SmallButton>
          <SmallButton onClick={stayActive}>{t(strCode.STAY_LOGGED_IN_BTN)}</SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

IdleModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired
};

export default withSection(IdleModal);
